import script from "./ModalJoinCampaign.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalJoinCampaign.vue?vue&type=script&setup=true&lang=js"

import "./ModalJoinCampaign.vue?vue&type=style&index=0&id=178bbeac&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-178bbeac"]])

export default __exports__